import type { RootState } from '@/store';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { withNormalizedCustomFieldPayload } from '@/shared/utils/customFieldPayload';
import type {
  CreateCustomFieldInput,
  CustomFieldDefinition,
  CustomFieldListFilter,
  UpdateCustomFieldInput,
} from '../types';
import { customFieldsService } from './services';

export const fetchCustomFields = createAsyncThunk<
  CustomFieldDefinition[],
  CustomFieldListFilter | undefined,
  { rejectValue: string }
>('customFields/fetchCustomFields', async (filters, { rejectWithValue }) => {
  try {
    return await customFieldsService.listCustomFields(filters);
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar custom fields',
    );
  }
});

export const fetchCustomField = createAsyncThunk<
  CustomFieldDefinition,
  string,
  { rejectValue: string }
>('customFields/fetchCustomField', async (id, { rejectWithValue }) => {
  try {
    return await customFieldsService.getCustomField(id);
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar custom field',
    );
  }
});

export const createCustomField = createAsyncThunk<
  CustomFieldDefinition,
  CreateCustomFieldInput,
  { rejectValue: string; state: RootState }
>('customFields/createCustomField', async (data, { rejectWithValue, getState }) => {
  try {
    const state = getState();
    const user = state.auth.user;
    if (!user?.empresaId) {
      return rejectWithValue('Não autenticado');
    }

    return await customFieldsService.createCustomField(
      withNormalizedCustomFieldPayload(data, user),
    );
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao criar custom field');
  }
});

export const updateCustomField = createAsyncThunk<
  CustomFieldDefinition,
  { id: string; data: UpdateCustomFieldInput },
  { rejectValue: string }
>('customFields/updateCustomField', async ({ id, data }, { rejectWithValue }) => {
  try {
    return await customFieldsService.updateCustomField(id, data);
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao atualizar custom field',
    );
  }
});

export const deleteCustomField = createAsyncThunk<string, string, { rejectValue: string }>(
  'customFields/deleteCustomField',
  async (id, { rejectWithValue }) => {
    try {
      await customFieldsService.deleteCustomField(id);
      return id;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : 'Erro ao deletar custom field',
      );
    }
  },
);
